// Logos are referenced as emitted files (hashed URLs), not inlined via ?raw: each SVG embeds a ~60 KB bitmap,
// so inlining all locales/years put ~1.3 MB of JS on every page.
const logos = {
  cs: {
    '2024': require('@icon/logo/cs/2024.svg'),
    '2025': require('@icon/logo/cs/2025.svg'),
    '2026': require('@icon/logo/cs/2026.svg'),
    '2027': require('@icon/logo/cs/2027.svg'),
    '2028': require('@icon/logo/cs/2028.svg'),
    '2029': require('@icon/logo/cs/2029.svg'),
    '2030': require('@icon/logo/cs/2030.svg'),
    '2031': require('@icon/logo/cs/2031.svg'),
    '2032': require('@icon/logo/cs/2032.svg'),
    '2033': require('@icon/logo/cs/2033.svg'),
    '2034': require('@icon/logo/cs/2034.svg'),
  },
  de: {
    '2024': require('@icon/logo/de/2024.svg'),
    '2025': require('@icon/logo/de/2025.svg'),
    '2026': require('@icon/logo/de/2026.svg'),
    '2027': require('@icon/logo/de/2027.svg'),
    '2028': require('@icon/logo/de/2028.svg'),
    '2029': require('@icon/logo/de/2029.svg'),
    '2030': require('@icon/logo/de/2030.svg'),
    '2031': require('@icon/logo/de/2031.svg'),
    '2032': require('@icon/logo/de/2032.svg'),
    '2033': require('@icon/logo/de/2033.svg'),
    '2034': require('@icon/logo/de/2034.svg'),
  },
  sk: {
    '2024': require('@icon/logo/sk/2024.svg'),
    '2025': require('@icon/logo/sk/2025.svg'),
    '2026': require('@icon/logo/sk/2026.svg'),
    '2027': require('@icon/logo/sk/2027.svg'),
    '2028': require('@icon/logo/sk/2028.svg'),
    '2029': require('@icon/logo/sk/2029.svg'),
    '2030': require('@icon/logo/sk/2030.svg'),
    '2031': require('@icon/logo/sk/2031.svg'),
    '2032': require('@icon/logo/sk/2032.svg'),
    '2033': require('@icon/logo/sk/2033.svg'),
    '2034': require('@icon/logo/sk/2034.svg'),
  },
}

// Intrinsic width of the SVGs (viewBox, height 88)
const widths = {
  de: 224,
}

export function getLogoUrl(lang, year = new Date().getFullYear()) {
  const byLang = logos[lang] || logos.cs
  return byLang[year] || byLang['2034']
}

export function getLogoWidth(lang) {
  return widths[lang] || 241
}
